module.exports = __webpack_public_path__ + "static/media/jpmcc.cb7a3911.png";